<div class="login-page" authTheme>
  @if (success) {
    <app-confetti/>
  }
    <div class="login-container">

    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
      <h2 class="h3 mb-2">Reset Password</h2>
      <p class="text-muted">
        Enter your new password for: <b>{{ userEmail }}</b>
      </p>
    </div>

    @if (errorMessage) {
      <div class="alert alert-danger text-center" role="alert">
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ errorMessage }}
      </div>
    }

    <div class="signup-form">
        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
          <app-form-password
            label="Password"
            placeholder="Create a strong password"
            formControlName="password"
            [required]="true"
            [showRequirements]="true"
            [errorMessage]="getErrorMessage('password')"
          ></app-form-password>

          <app-form-password
            label="Confirm Password"
            placeholder="Re-enter your password"
            formControlName="confirmPassword"
            [required]="true"
            [errorMessage]="getErrorMessage('confirmPassword')"
          ></app-form-password>

          <button
            type="submit"
            class="btn btn-primary w-100 mt-3"
            [disabled]="loading || resetForm.invalid"
          >
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            {{ loading ? 'Resetting Password...' : 'Confirm Password Reset' }}
          </button>

          <div class="text-center mt-3">
            <button
              type="button"
              class="btn btn-link p-0"
              (click)="goBackToLogin()"
              [disabled]="loading"
            >
              <i class="bi bi-arrow-left me-2"></i>
              Back to Login
            </button>
          </div>
        </form>
      </div>
</div>
